// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__QUMuE","small":"Avatar_small__NVIXE","large":"Avatar_large__PLk3B"};